module.exports = __webpack_public_path__ + "img/illustrations/drag-and-drop-overlay-7c8d1827bb78d8f62483ce6235ec8d02.svg";